(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["paymentpopup"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
  const modal = document.getElementById('allPaymentsModal');
  const closeBtn = document.getElementById('closePayments');
  const viewAll = document.querySelector('.view-all-btn');

  const showModal = () => modal.removeAttribute('hidden');
  const hideModal = () => modal.setAttribute('hidden', '');

  viewAll?.addEventListener('click', showModal);
  closeBtn?.addEventListener('click', hideModal);
  modal?.addEventListener('click', e => {
    if (e.target === modal) hideModal();
  });
});
  } catch(e) { console.error(e); }
})();

})();
